define('views/modules/questionnaire/questionnaire-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // Views
    'views/parts/panel/base-panel',
    'views/modules/questionnaire/questionnaire-content'

], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VBasePanel,
    VQuestionnaireContent
) {

    var VQuestionnairePanel = VBasePanel.extend({
        header: {
            title: "questionnaire:My Questionnaires",
            subtitle: "questionnaire:Create or view your questionnaires"
        },

        tabs: [{ id: 'questionnaire', title: 'questionnaire:List', active: true }],

        content: {
            questionnaire: VQuestionnaireContent
        },

        defaultView: 'questionnaire',

        initialize: function(opt) {
            opt = opt || {};
            var questionnaire = this.getView('questionnaire', {
                model: this.model,
                group: opt.group,
                url: opt.url,
            });

            this.listenTo(questionnaire, {
                'post:success': this.close,
                'form:success': this.close,
            });
        },

    });

    return VQuestionnairePanel;

});

